import videoUrlParser from 'js-video-url-parser';
import YouTubeExtend from '../../javascripts/js-video-url-parser/provider/youtube';
import { fetchWithTimeout } from '../api_utils';
videoUrlParser.plugins.youtube = new YouTubeExtend();

class ViewMode {
  constructor($element) {
    this.$element = $element;
  }

  replace() {
    document.querySelectorAll('oembed[url]').forEach(async (elem) => {
      const videoInfo = videoUrlParser.parse(elem.attributes.url.value);

      if (videoInfo) {
        switch (videoInfo.provider) {
          case 'vimeo':
            elem.parentElement.innerHTML = this.createVideoBlock(
              `//player.vimeo.com/video/${videoInfo.id}`,
            );
            break;
          case 'youtube':
            elem.parentElement.innerHTML = this.createVideoBlock(
              `//www.youtube.com/embed/${videoInfo.id}`,
            );
            break;
        }
      }
    });

    document
      .querySelectorAll('figure.media a[href*="youtube.com/shorts/"]')
      .forEach((elem) => {
        const url = elem.getAttribute('href');
        const videoId = this.extractYouTubeVideoId(url);

        if (videoId) {
          const figureElement = elem.closest('figure.media');
          if (figureElement) {
            figureElement.outerHTML = this.createYouTubeShortsBlock(videoId);
          }
        }
      });
  }

  extractYouTubeVideoId(url) {
    const match = url.match(/youtube\.com\/shorts\/([^?]+)/);
    return match ? match[1] : null;
  }

  createYouTubeShortsBlock(videoId) {
    const container = document.createElement('div');
    container.style.cssText =
      'position: relative; padding-bottom: 56.2493%; height: 0;';

    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}`);
    iframe.style.cssText =
      'position: absolute; width: 100%; height: 100%; top: 0; left: 0;';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay; encrypted-media');
    iframe.setAttribute('allowfullscreen', '');

    container.appendChild(iframe);
    return container.outerHTML;
  }

  createVideoBlock(url) {
    const videoContainer = document.createElement('div');
    const iframe = document.createElement('iframe');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '100%');
    iframe.setAttribute('src', url);
    iframe.setAttribute('frameborder', 0);
    iframe.setAttribute('allowfullscreen', '');
    videoContainer.className = 'video-container';
    videoContainer.appendChild(iframe);
    return videoContainer.outerHTML;
  }
}

export default ViewMode;
